module.exports = __webpack_public_path__ + "img/icon-business-receive-06.svg";